import styled from 'styled-components';
// import { darken } from 'polished';//scss function, not available in styled components
import { BubbleHoverCircleProps } from './types';


const BubbleHoverCircle = styled.div<BubbleHoverCircleProps>`
    position: relative;
    width: ${({$width, $size}) => $width || $size || '280px'};
    height: ${({$height, $size}) => $height || $size || '280px'};
    display: flex; 
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background: transparent;
    border-radius: 50%;
    transition: all 0.5s cubic-bezier(.55,0,.1,1);
    z-index: 1;


        
    &:hover {
        background-size: 115%;
        .outercirle {
            transform: rotate(-45deg) translate(0px) rotate(-315deg);
            background: ${({$hoverBackground}) => $hoverBackground || ' rgba(184, 49, 182, 0.3)' };
            width: ${({$widthOuterCircleHover, $sizeOuterCircleHover}) => $widthOuterCircleHover || $sizeOuterCircleHover || '280px'};
            height: ${({$heightOuterCircleHover, $sizeOuterCircleHover}) => $heightOuterCircleHover || $sizeOuterCircleHover || '280px'};
            font-size: ${({$fontSizeHover}) => $fontSizeHover || '15px' };
            letter-spacing: ${({$letteSpacingHover}) => $letteSpacingHover || '9px' };
            font-weight: bold;
            margin-top: ${({$marginTopHover, $marginTopAndLeftHover}) => $marginTopHover || $marginTopAndLeftHover || '-140px'};
            margin-left: ${({$marginLeftHover, $marginTopAndLeftHover}) => $marginLeftHover || $marginTopAndLeftHover || '-140px'};
            transition: all 0.5s cubic-bezier(.55,0,.1,1), letter-spacing 1.5s ease-out;
            z-index: 3;

            img {
             display: none;
            }

            span {
            display: block;
                opacity: ${({$opacityByDefault}) => $opacityByDefault || '1'};
            }

        }
    }

    .outercirle {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        text-align: center;
        font-size: ${({$fontSize}) => $fontSize || '10px' };
        letter-spacing: ${({$letteSpacing}) => $letteSpacing || '0px' };
        box-sizing: border-box;
        border-radius: 50%;
        width: ${({$widthOuterCircle, $sizeOuterCircle}) => $widthOuterCircle || $sizeOuterCircle || '100px'};
        height: ${({$heightOuterCircle, $sizeOuterCircle}) => $heightOuterCircle || $sizeOuterCircle || '100px'};
        background: ${({$outerBackground}) => $outerBackground || 'linear-gradient( #FF00D6, #FF4D00)' };
        left: 50%;
        top: 50%;
        margin-top: ${({$marginTop,  $marginTopAndLeft}) => $marginTop || $marginTopAndLeft || '-25px'};
        margin-left: ${({$marginLeft, $marginTopAndLeft}) => $marginLeft || $marginTopAndLeft || '-25px'};
        transform: rotate(-135deg)
        translate(-100px) rotate(135deg);
        z-index: 2;
        transition: ${({$transition}) => $transition || 'all 0.5s cubic-bezier(.55,0,.1,1)' };
        color: #fff;

        img {
            display: block;
            transition: display 0.7s ease;
        }

        span {
            display: ${({$displayOnSpan}) => $displayOnSpan || 'block' };
            opacity: 0;
            transition: opacity 0.7s ease;
             font-weight: bold;
        }

    }
`;

export default BubbleHoverCircle

// ${({$bubbleTextColor, theme}) => $bubbleTextColor || theme.circularIconTextBg}, add the theme as function in the types